import { gql } from '@apollo/client';
import React from 'react';
import Helmet from 'react-helmet';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

const BreadcrumbWrapper = styled.div`
  margin-left: 15px;
  a {
    &:hover {
      text-decoration: none;
    }
  }
  .breadcrumb-text {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 23px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #6c6c6c;
    opacity: 0.9;
  }

  .category-name {
    cursor: pointer;
  }

  .frame-name {
    display: inline;
    color: ${({ theme }) => theme.colors.charcoal};
  }

  .home-link {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    margin-left: 15px;
    .breadcrumb-text {
      font-size: 12px;
    }
  }
`;

const getCategory = str => {
  const lastSlash = str.substring(0, str.lastIndexOf('/'));
  return lastSlash;
};

const getName = str => {
  return str.replace(/-/g, ' ');
};

const titleCase = str => {
  return str
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
};

const getMetaTitle = str => {
  const frameName = titleCase(getName(str));
  return `Custom ${frameName} - 100+ Fabrics for Custom Upholstered ${frameName} | The Inside Furniture`;
};

const getMetaDesc = str => {
  return `Shop for ${titleCase(
    getName(str)
  )} in 100+ prints at The Inside. All products are made from scratch. Customize yours today.`;
};

function Breadcrumb(props) {
  const location = useLocation();
  const match = useRouteMatch();
  const frameSlug = match.params.frameSlug;
  const categorySlug = match.params.categorySlug;
  const frameTitle =
    frameSlug === '20-throw-pillow' ? `20"-throw-pillow` : frameSlug;

  return (
    <BreadcrumbWrapper>
      <Helmet>
        <title>{getMetaTitle(getName(match.params.frameSlug))}</title>
        <meta
          name="description"
          content={getMetaDesc(getName(titleCase(match.params.frameSlug)))}
        />
      </Helmet>
      <Link className="breadcrumb-text home-link" to="/">
        Custom Furniture Home <span className="mx-2">/</span>{' '}
      </Link>
      <Link
        className="breadcrumb-text category-name"
        to={getCategory(location.pathname)}
      >
        Custom {getName(categorySlug)} <span className="mx-2">/</span>{' '}
      </Link>
      <h1 className="breadcrumb-text frame-name">{getName(frameTitle)}</h1>
    </BreadcrumbWrapper>
  );
}

export default Breadcrumb;

export const FRAME_BY_SLUG = gql`
  query frameBySlug($slug: String!) {
    frameBySlug(slug: $slug) {
      id
      name
      subcategories {
        id
        name
        category {
          id
          name
        }
      }
    }
  }
`;
